



















import { Component, Vue, Watch } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState({
      rateLimitException: "rateLimitException",
      rateLimitRetryAfter: "rateLimitRetryAfter"
    }),
  }
})
export default class QThrottleDialog extends Vue {
  rateLimitDialog = false
  rateLimitExceptionRetryAfter = 0

  rateLimitException!: boolean
  rateLimitRetryAfter!: number

  @Watch("rateLimitException")
  watchRateLimitException() {
    this.rateLimitDialog = this.rateLimitException
    // Create an interval if there is a rate limit exception and local retryAfter is zero
    if (this.rateLimitException && this.rateLimitExceptionRetryAfter == 0) {
      
      this.rateLimitExceptionRetryAfter = this.rateLimitRetryAfter || 0
      // Create an interval
      const interval = setInterval(() => {
        // If local retryAfter is zero, clear interval, close the dialog, and disable tthe rate limit exception
        if (this.rateLimitExceptionRetryAfter == 0) {
          clearInterval(interval)
          this.rateLimitDialog = false
          this.$store.commit("SET_RATE_LIMIT_EXCEPTION", false)
          return
        }
        this.rateLimitExceptionRetryAfter -= 1
      }, 1000)
    }
  }
}
